import { deleteClientCityRangeRequest } from "../../data/clientCityRangeApi";

export async function deleteClientCityRangeUseCase(id) {
  if (!Number.isInteger(Number(id)) || Number(id) <= 0) {
    throw new Error("El id de la tarifa por rango es obligatorio.");
  }

  return await deleteClientCityRangeRequest(id);
}
